import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/functions'
import { firebaseConfig } from './firebaseConfig'

const config = {
  apiKey: firebaseConfig.API_KEY,
  authDomain: `${firebaseConfig.PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${firebaseConfig.PROJECT_ID}.firebaseio.com`,
  projectId: `${firebaseConfig.PROJECT_ID}`,
  storageBucket: `${firebaseConfig.PROJECT_ID}.appspot.com`,
  appId: firebaseConfig.PROJECT_ID,
}

export const initFirebase = ():firebase.app.App => {
  const firebaseService = firebase.initializeApp(config)
  if ((process.env.NX_FIREBASE_ENVIRONMENT !== 'undefined' ? process.env.NX_FIREBASE_ENVIRONMENT : process.env.NX_ENV) === 'LOCAL') {
    firebase.auth().useEmulator('http://localhost:9099')
    firebase.functions().useEmulator('localhost', 5001)
  }

  return firebaseService
}

export const firebaseService = initFirebase()
export const firebaseEastRegion = process.env.NX_FIREBASE_ENVIRONMENT === 'LOCAL' ? undefined : 'europe-central2'
